import { jsx as o, jsxs as t, Fragment as s } from "react/jsx-runtime";
import { Icon as c } from "../../../../../components/Icon/index.js";
import { Nickname as l } from "../../../../../components/Nickname/index.js";
import { htmlToPlainText as p } from "../../../../../services/html/index.js";
import { removeNotParsedHtmlSymbols as d } from "../../../../../services/strings/index.js";
import { FooterLastCommentCard as h, FooterLastCommentParagraph as C, EmptyComment as f } from "./style.js";
import { Stars as T } from "@pelando/fontawesome/icons";
const x = "ultimo comentário desta promoção", y = ({
  commentId: r,
  authorNickname: m,
  contentLabel: e = x,
  lastComment: n,
  onClick: a
}) => {
  const i = p(d(n));
  return /* @__PURE__ */ o(h, { onClick: () => a(r || ""), children: /* @__PURE__ */ o(C, { "aria-label": e, children: r ? /* @__PURE__ */ t(s, { children: [
    /* @__PURE__ */ t("strong", { children: [
      "@",
      /* @__PURE__ */ o(l, { children: m })
    ] }),
    i
  ] }) : /* @__PURE__ */ t(f, { "data-testid": "empty-comment", children: [
    /* @__PURE__ */ o(c, { icon: T }),
    "Seja a primeira pessoa a comentar!"
  ] }) }) });
};
export {
  y as FooterLastComment
};
